export const BASE_REVIEW_PATH = '/reviews';

export const INDEX_REVIEW_PATH = `${ BASE_REVIEW_PATH }/all`;
export const NEW_REVIEW_PATH = `${ BASE_REVIEW_PATH }/new`;
export const EDIT_REVIEW_PATH = `${ BASE_REVIEW_PATH }/edit/:id`;
